import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SortDirection } from '../../utils/SortUtils';
import Select from '../selects/Select';
import ToggleButton from '../button/ToggleButton';
class TableCardsSorting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortName: this.props.sortName,
            sortOrder: this.props.sortOrder,
        };
        this.setSortName = this.setSortName.bind(this);
        this.setSortDirectionAsc = this.setSortDirectionAsc.bind(this);
        this.setSortDirectionDesc = this.setSortDirectionDesc.bind(this);
    }
    setSortDirectionAsc() {
        this.setSortDirection(SortDirection.ASCENDING);
    }
    setSortDirectionDesc() {
        this.setSortDirection(SortDirection.DESCENDING);
    }
    setSortDirection(direction) {
        this.setState({
            sortOrder: direction,
        });
        this.props.onSortChange(this.state.sortName, direction);
    }
    setSortName(item) {
        this.setState({
            sortName: item.id,
        });
        this.props.onSortChange(item.id, this.state.sortOrder);
    }
    render() {
        const { className, selectOptions } = this.props;
        const { sortOrder } = this.state;
        const wrapperClassNames = classNames('table-toolbar-cards-sorting', 'btn-toolbar', className && className);
        return (_jsxs("div", Object.assign({ className: wrapperClassNames }, { children: [_jsxs("div", Object.assign({ className: 'btn-group margin-left-0' }, { children: [_jsx(ToggleButton, Object.assign({ className: 'btn-icon-only', active: sortOrder === SortDirection.ASCENDING, onClick: this.setSortDirectionAsc }, { children: _jsx("span", { className: 'rioglyph rioglyph-sort-by-attributes-alt' }) })), _jsx(ToggleButton, Object.assign({ className: 'btn-icon-only', active: sortOrder === SortDirection.DESCENDING, onClick: this.setSortDirectionDesc }, { children: _jsx("span", { className: 'rioglyph rioglyph-sort-by-attributes' }) }))] })), selectOptions.length && (_jsx("div", Object.assign({ className: 'btn-group' }, { children: _jsx(Select, { options: selectOptions, onChange: this.setSortName }) })))] })));
    }
}
TableCardsSorting.defaultProps = {
    onSortChange: () => { },
    sortOrder: SortDirection.ASCENDING,
    selectOptions: [],
};
TableCardsSorting.propTypes = {
    sortName: PropTypes.string.isRequired,
    sortOrder: PropTypes.oneOf([SortDirection.ASCENDING, SortDirection.DESCENDING]).isRequired,
    onSortChange: PropTypes.func,
    selectOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        selected: PropTypes.bool,
        disabled: PropTypes.bool,
    })).isRequired,
    className: PropTypes.string,
};
export default TableCardsSorting;
